import React, { Component } from "react";
import FlexText from "../../flexText";
import Styles from "../styles/videoStyles";
import Icon from "../../pageElements/icon";

class VideoHead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pause: false,
      type: "Pau",
    };
  }

  handlePausePlay = (event) => {
    let video = event.target;
    let button = event.target;
    // If button clicked, get video tag
    if (video.nodeName !== "VIDEO") {
      while (button.nodeName !== "BUTTON") {
        button = button.parentElement;
      }
      video = button.nextElementSibling;
    }
    if (this.state.pause === true) {
      video.play();
      this.setState({ type: "Pau", pause: false });
    } else {
      video.pause();
      this.setState({ type: "Pla", pause: true });
    }
  };

  render() {
    const {
      title,
      autoPlay,
      id,
      controls,
      loop,
      className,
      blockStyle,
      media,
      token,
    } = this.props;
    let sourceUrl = media.url;
    if (
      window.innerWidth < 600 &&
      typeof media.field_link_600 !== "undefined"
    ) {
      sourceUrl = media.field_link_600;
    } else if (
      window.innerWidth < 900 &&
      typeof media.field_link_900 !== "undefined"
    ) {
      sourceUrl = media.field_link_900;
    }
    return (
      <div className={className} tabIndex="-1">
        {typeof title !== "undefined" ? (
          <FlexText
            color={
              blockStyle.attributes.field_heading_color_font[0].field_color_1
            }
            tag="h4"
            max="40"
            min="40"
            blockStyles={{
              position: "absolute",
              height:
                (window.innerWidth > 1200 ? 1200 : window.innerWidth) * 0.2817 +
                "px",
              top: 0,
              width: "100%",
              padding: "68px 0 50px",
              background:
                "url('https://www.uvm.edu/content/files/backgrounds/gradient.png?t='" +
                token +
                ") no-repeat",
              backgroundSize:
                "100% " +
                (window.innerWidth > 1200 ? 1200 : window.innerWidth) * 0.2817 +
                "px",
            }}
            styles={{
              textAlign: "center",
              fontFamily: "Oswald",
              textTransform: "uppercase",
              padding: "0px",
              margin: "0",
            }}
          >
            {title}
          </FlexText>
        ) : null}
        {id === "headerVideo" ? (
          <button
            id={"vidbtn" + this.props.id}
            style={Styles.pauseButton}
            onClick={this.handlePausePlay}
          >
            <Icon type={this.state.type} />
          </button>
        ) : null}
        <video
          onClick={this.handlePausePlay}
          tabIndex="-1"
          id={"vid" + this.props.id}
          autoPlay={autoPlay}
          muted="muted"
          controls={controls}
          loop={loop}
          playsInline={true}
          style={{
            width: "100%",
            height: "calc(100%/1.7777)",
            border: "1px solid #F7F7F7",
          }}
        >
          <source src={sourceUrl} type="video/mp4" />
        </video>
      </div>
    );
  }
}

export default VideoHead;
